import {get} from './manage.js'

//轮播图
export const swiper = p => get('/geopark/geoCarousel/frontList', p)
//下载中心
export const download = p => get('/geopark/geoDownloadCenter/frontList', p)
//公园简介
export const profile = p => get('/geopark/geoParkProfile/frontList', p)
//地质旅游
export const travel = p => get('/geopark/geoGeologicalTourism/frontList', p)
//姊妹公园
export const sister = p => get('/geopark/geoSisterPark/frontList', p)
//新闻中心
export const newscenter = p => get('/geopark/geoPressCenter/frontList', p)
//科普教育
export const teach = p => get('/geopark/geoScienceEducation/frontList', p)
//资源保护
export const resource = p => get('/geopark/geoConservation/frontList', p)
//官网信息
export const info = p => get('/geopark/geoWebsiteInformation/frontList', p)

//官网信息
export const queryById = p => get('/geopark/queryById', p)
